import { Metric } from "@/entities/Finance/Finance.model";

/**
 * Get a specific metric from the metrics object with fallback
 */
export function getMetric(
    metrics: Record<string, Metric>,
    primaryLabel: string,
    fallbackLabel?: string,
): Metric | undefined {
    return (
        metrics[primaryLabel] ??
        (fallbackLabel ? metrics[fallbackLabel] : undefined)
    );
}
